import {SERVICES} from '@/const/services';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;

export const CRYPTO_CONVERT = {
  BANNER: '30f366b863d7b22e753ec004f8599e1a1b55749ba5f92bdd1de0e9f47e25c946.png',
  M_BANNER: 'cd29b4b1b63dcfabc859ba20e2c4d70d01856a18a040d292b2708b76ed549998.png',
  CONVERT: 'ffbe3afaf92a89435a6c465da4ada5dc95ce1ee2384b76497013e44273a37865.png',
  CONVERT_DISABLED: '22dc33c0500f16f3e1f018056b3a8f42a709207dfc13286857d1d926d65ea294.png',
  SUCCESS: '6e3644c4a966963a5ea3adb1f2a0b56fd4f382c94483ec745d87e48254e3ffb8.png',
  FAIL: '3f2dbcdcf0fb08f72db81eafcdee223a35decf8c19ab15ed7abcec028c3346a6.png',
};

Object.keys(CRYPTO_CONVERT).forEach((key) => (CRYPTO_CONVERT[key] = [PREFIX_RECEIVE, CRYPTO_CONVERT[key]].join('')));
